/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Daftar_GInputs */

const en_mk_tut_daftar_g = /** @type {(inputs: Mk_Tut_Daftar_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating an account uses your work email. No card is asked for at this stage.`)
};

const id_mk_tut_daftar_g = /** @type {(inputs: Mk_Tut_Daftar_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat akun memakai email kerja Anda. Tidak ada kartu kredit yang diminta pada tahap ini.`)
};

/**
* | output |
* | --- |
* | "Creating an account uses your work email. No card is asked for at this stage." |
*
* @param {Mk_Tut_Daftar_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_daftar_g = /** @type {((inputs?: Mk_Tut_Daftar_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Daftar_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_daftar_g(inputs)
	return en_mk_tut_daftar_g(inputs)
});